/**
 * The template tags blocking a clause mutation (409 lifecycle conflict),
 * rendered as copyable monospace chips so the author can take each tag
 * straight to Word's search box while migrating the template. Renders
 * nothing for an empty list.
 */

import TagPreview from './TagPreview';

export interface ConflictTagListProps {
  tags: string[];
}

export default function ConflictTagList({ tags }: ConflictTagListProps) {
  if (tags.length === 0) return null;
  return (
    <span className="mt-1 flex flex-wrap items-center gap-x-3 gap-y-1">
      <span className="font-medium">Referencing tags:</span>
      {tags.map((tag) => (
        <TagPreview key={tag} tag={tag} variant="plain" label={`tag {${tag}}`} />
      ))}
    </span>
  );
}
